import type { IntegrationType } from "@v2/features/settings/shop/integrations/IntegrationForm";
import type { IntegrationStatus } from "./IntegrationStatusTag";

import * as React from "react";

import { INTEGRATION_CONFIGS } from "@v2/features/settings/shop/integrations/config";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";
import { routes } from "@v2/utils/router";
import { generatePath, useNavigate } from "react-router-dom";

import IntegrationStatusTag from "./IntegrationStatusTag";

type IntegrationGridCardProps = {
  integrationType: IntegrationType;
  status: IntegrationStatus;
};

const IntegrationGridCard: React.FC<IntegrationGridCardProps> = ({
  integrationType,
  status,
}) => {
  const navigate = useNavigate();
  const projectId = useCurrentProjectId();
  const config = INTEGRATION_CONFIGS[integrationType];
  const goToDetail = () => {
    navigate(
      generatePath(routes.shops.integrations.detail, {
        projectId: projectId ?? "",
        integrationType,
      }),
    );
  };

  return (
    <div
      className="group relative flex flex-col gap-3 rounded-xl border-0.5 border-border p-4 transition-colors min-h-[140px] hover:bg-button-secondary-hover cursor-pointer shadow-xs"
      onClick={goToDetail}
    >
      {/* Top row: logo + status */}
      <div className="flex items-start justify-between">
        <img
          src={config.image}
          alt={config.title}
          className="size-9 rounded-lg object-contain"
        />
        <IntegrationStatusTag status={status} />
      </div>

      {/* Title + description */}
      <div className="flex flex-col gap-0.5">
        <span className="text-sm font-medium text-default break-words">
          {config.title}
        </span>
        <span className="text-xs text-muted break-words leading-relaxed line-clamp-2">
          {config.description}
        </span>
      </div>
    </div>
  );
};

export default IntegrationGridCard;
